import React from 'react';
import { Accordion, AccordionItem } from '@appkit4/react-components/accordion';

interface AccordionItemData {
    title: string;
    images: { url: string, subtitle: string, variableSubtitle: string }[];
}

interface Props {
    items: AccordionItemData[];
}

const AccordionSample: React.FC<Props> = ({ items }) => {
    const [activeKeys, setActiveKeys] = React.useState<string[]>([]);
    const [isHovered, setIsHovered] = React.useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const onClickAccordion = (activeKeys: string[]) => {
        setActiveKeys(activeKeys);
    }

    return (
        <div className="accordion-container">
            <Accordion 
                multiple={false} 
                onClick={onClickAccordion} 
                activeKeys={activeKeys} 
                style={{filter: isHovered ? `brightness(90%)` : 'brightness(100%)', backgroundColor: '#252525' , borderRadius: '10px' }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                {items.map((item, index) => (
                    <AccordionItem 
                        key={index} 
                        title={item.title} 
                        itemKey={index.toString()} 
                        expanded={true} 
                        style={{ margin: '10px', padding: '15px'}}
                    >
                        <div className="AccordionItem-content" style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div className="AccordionItem-left" style={{ marginRight: '10px' }}>
                                {/* Left Area */}
                            </div>
                            <div className="AccordionItem-main" style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }}>
                                {/* Main Area */}
                                <div className="AccordionItem-images">
                                    {item.images.map((image, idx) => (
                                        <div key={idx} className="AccordionItem-image" style={{ marginBottom: '10px' }}>
                                            <img src={image.url} alt={item.title} style={{ maxWidth: '40%', height: 'auto', marginRight: '10px' }} />
                                            <p style={{ marginTop: '10px', marginBottom: '10px', fontWeight: 'bold', fontSize: 'larger' }}>{`${image.subtitle}`}</p>
                                            <p style={{ marginTop: '10px', marginBottom: '10px' }}>{`${image.variableSubtitle}`}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="AccordionItem-right" style={{ marginLeft: '10px' }}>
                                {/* Right Area */}
                            </div>
                        </div>
                    </AccordionItem>
                ))}
            </Accordion>
        </div>
    );
}

export default AccordionSample;